import React, { useState } from 'react';
import { SaveIcon, InfoIcon, CheckCircleIcon } from 'lucide-react';
import { AdminApproval } from '../components/common/AdminApproval';
export function Configurations() {
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [formData, setFormData] = useState({
    readTimeoutValue: 30,
    readTimeoutUnit: 'seconds',
    idleTimeoutValue: 15,
    idleTimeoutUnit: 'minutes',
    invalidPasswordAttempts: 3,
    passwordExpiryDays: 90,
    enable2FA: 'no'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target as HTMLInputElement;
    if (type === 'number') {
      let numValue = parseInt(value);
      // Apply min/max constraints
      if (name === 'invalidPasswordAttempts') {
        numValue = Math.min(Math.max(numValue, 1), 10);
      } else if (name === 'passwordExpiryDays') {
        numValue = Math.min(Math.max(numValue, 30), 365);
      }
      setFormData({
        ...formData,
        [name]: numValue
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowApprovalModal(true);
  };
  const handleApprove = () => {
    setShowApprovalModal(false);
    // Here you would typically save the configuration to your backend
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };
  const handleReject = () => {
    setShowApprovalModal(false);
  };
  return <div className="space-y-6" data-id="element-533">
      <div className="flex justify-between items-center" data-id="element-534">
        <h1 className="text-2xl font-bold text-[#1A1F36]" data-id="element-535">Configurations</h1>
      </div>
      {showSuccessMessage && <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative flex items-center" data-id="element-536">
          <CheckCircleIcon size={20} className="mr-2" data-id="element-537" />
          <span data-id="element-538">Configuration updated successfully!</span>
        </div>}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6" data-id="element-539">
        <form onSubmit={handleSubmit} data-id="element-540">
          <div className="space-y-6" data-id="element-541">
            <div data-id="element-542">
              <h2 className="text-lg font-medium text-[#1A1F36] mb-4" data-id="element-543">
                System Timeouts
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-544">
                <div data-id="element-545">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-546">
                    Read Time Out
                  </label>
                  <div className="flex space-x-2" data-id="element-547">
                    <input type="number" name="readTimeoutValue" min="1" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.readTimeoutValue} onChange={handleChange} data-id="element-548" />
                    <select name="readTimeoutUnit" className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.readTimeoutUnit} onChange={handleChange} data-id="element-549">
                      <option value="seconds" data-id="element-550">Seconds</option>
                      <option value="minutes" data-id="element-551">Minutes</option>
                      <option value="hours" data-id="element-552">Hours</option>
                    </select>
                  </div>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-553">
                    Maximum time for API read operations
                  </p>
                </div>
                <div data-id="element-554">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-555">
                    Idle Time Out
                  </label>
                  <div className="flex space-x-2" data-id="element-556">
                    <input type="number" name="idleTimeoutValue" min="1" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.idleTimeoutValue} onChange={handleChange} data-id="element-557" />
                    <select name="idleTimeoutUnit" className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.idleTimeoutUnit} onChange={handleChange} data-id="element-558">
                      <option value="seconds" data-id="element-559">Seconds</option>
                      <option value="minutes" data-id="element-560">Minutes</option>
                      <option value="hours" data-id="element-561">Hours</option>
                    </select>
                  </div>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-562">
                    Time after which inactive users are logged out
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6" data-id="element-563">
              <h2 className="text-lg font-medium text-[#1A1F36] mb-4" data-id="element-564">
                Security Settings
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-565">
                <div data-id="element-566">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-567">
                    Invalid Password Attempts
                  </label>
                  <input type="number" name="invalidPasswordAttempts" min="1" max="10" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.invalidPasswordAttempts} onChange={handleChange} data-id="element-568" />
                  <p className="mt-1 text-sm text-gray-500" data-id="element-569">
                    Number of attempts before account is locked (1-10)
                  </p>
                </div>
                <div data-id="element-570">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-571">
                    Password Expires After (Days)
                  </label>
                  <input type="number" name="passwordExpiryDays" min="30" max="365" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" value={formData.passwordExpiryDays} onChange={handleChange} data-id="element-572" />
                  <p className="mt-1 text-sm text-gray-500" data-id="element-573">
                    Days until password must be changed (30-365)
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6" data-id="element-574">
              <h2 className="text-lg font-medium text-[#1A1F36] mb-4" data-id="element-575">
                Authentication
              </h2>
              <div data-id="element-576">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-577">
                  Enable Two-Factor Authentication (2FA) for All Users
                </label>
                <div className="flex space-x-4 mt-2" data-id="element-578">
                  <label className="inline-flex items-center" data-id="element-579">
                    <input type="radio" name="enable2FA" value="yes" className="form-radio text-[#F58220] focus:ring-[#F58220]" checked={formData.enable2FA === 'yes'} onChange={handleChange} data-id="element-580" />
                    <span className="ml-2" data-id="element-581">Yes</span>
                  </label>
                  <label className="inline-flex items-center" data-id="element-582">
                    <input type="radio" name="enable2FA" value="no" className="form-radio text-[#F58220] focus:ring-[#F58220]" checked={formData.enable2FA === 'no'} onChange={handleChange} data-id="element-583" />
                    <span className="ml-2" data-id="element-584">No</span>
                  </label>
                </div>
                <div className="mt-2 flex items-start text-sm text-gray-500" data-id="element-585">
                  <InfoIcon size={16} className="mr-2 mt-0.5 flex-shrink-0" data-id="element-586" />
                  <p data-id="element-587">
                    When enabled, all users will be required to set up
                    two-factor authentication during their next login.
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6 flex justify-end" data-id="element-588">
              <button type="submit" className="flex items-center px-4 py-2 bg-[#F58220] text-white rounded-md hover:bg-[#e07619]" data-id="element-589">
                <SaveIcon size={16} className="mr-2" data-id="element-590" />
                Save Configuration
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* Admin Approval Modal */}
      <AdminApproval isVisible={showApprovalModal} onClose={() => setShowApprovalModal(false)} onApprove={handleApprove} onReject={handleReject} title="Approve Configuration Changes" description="Please review and approve the following configuration changes. These changes will affect system-wide behavior." data-id="element-591" />
    </div>;
}